import { Flex, Text } from '@raystack/apsara';

import { SquareThumbnail } from '@src/components/Custom/Thumbnails';

import { AssetTextWrapper } from './AssetTextWrapper';

const InputTile = ({ title, name, description, src }) => {
  return (
    <Flex direction='column' gap='small' align='start'>
      <Text variant='primary' size={4} weight={500}>
        {title}
      </Text>

      <Flex gap='small' align='center'>
        <SquareThumbnail src={src} />
        <AssetTextWrapper title={name} date={description} />
      </Flex>
    </Flex>
  );
};
export default InputTile;
